import React from "react";
import PayfastPayment from "./PayfastPayment";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PayFast = () => {
    const userId = useSelector((state) => state.authenticationSlice?.userId);
    console.log(userId, "userId"); // Debugging log to check userId value
    const location = useLocation();
    const decryptedResponse = location.state?.data;

    if (!decryptedResponse) {
        console.error("Error: decryptedResponse is undefined or null.");
        return <div>Error: Unable to process payment. Please try again later.</div>;
    }

    const fare = decryptedResponse?.data?.schedule?.fare;
    const rideId = decryptedResponse?.data?.schedule?._id;

    if (!fare || !rideId) {
        console.error("Error: Missing fare or rideId in decryptedResponse.");
        return <div>Error: Invalid payment details. Please contact support.</div>;
    }

    console.log(rideId, "rideId"); // Debugging log to check rideId value
    console.log(decryptedResponse, "decryptedResponse"); // Debugging log to check decryptedResponse value
    console.log("fare payfast", fare); // Debugging log to check fare value

    const requestModel = {
        merchantId: "16590",
        merchantName: "sha",
        procCode: "00",
        txnAmt: fare, // Use fare prop for transaction amount
        customerMobileNo: "1234567890",
        customerEmailAddress: "user@example.com",
        signature: "John Doe", // Signature can be set dynamically
        version: "1.1",
        txnDesc: "Remaining payment from user",
        successUrl: "https://yourdomain.com/api/payment/payfast/success", // Updated success URL
        failureUrl: "https://yourdomain.com/api/payment/payfast/failure", // Updated failure URL
        basketId: rideId, // Dynamic basket ID
        orderDate: new Date().toISOString().split("T")[0], // Current Date
        checkoutUrl: "https://yourdomain.com/api/payment/payfast/checkout", // Updated checkout URL
        currencyCode: "PKR",
        customerName: "John Doe", // Customer full name
        merchantCustomerId: "1", // Dynamic customer ID
        country: "Pakistan",
    };

    const handlePaymentCallback = () => {
        alert("Payment process complete.");
    };

    console.log("requestModel payfast", requestModel); // Debugging log to check requestModel value

    return (
        <div>
            <h2 style={{ color: "red" }}>PayFast Payment</h2>
            <PayfastPayment requestModel={requestModel} callback={handlePaymentCallback} />
        </div>
    );
};

export default PayFast;
